// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.home__content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.home__list {
  width: 100%;
  overflow: hidden;
  overflow: auto;
}

.home__content > h1 {
  color: #777f87;
  font-size: 24px;
  font-weight: 600;
}

.list_users {
  min-width: 1024px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  list-style: none;
}

.list_users > :nth-child(odd) {
  background: transparent;
}

.list_users > :nth-child(odd) {
  border: 1px solid #dde1eb;
}

.list_users__header {
  width: 100%;
  display: flex;
  align-items: center;
  border: none !important;
}

.list_users__header > .w150 {
  text-align: center;
  border-right: 1px solid #b2bac6;
  color: #b2bac6;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  padding: 10px;
}

.list_users__header > .w180 {
  text-align: center;
  border-right: 1px solid #b2bac6;
  color: #b2bac6;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  padding: 10px;
  padding: 10px;
}

.list_users__header > .w450 {
  text-align: center;
  color: #b2bac6;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  padding: 10px;
  border-right: 1px solid #b2bac6;
  padding: 10px;
}

.list_users__header > :last-child {
  border-right: none;
}

.list_users .w150 {
  width: 150px;
  padding: 10px;
}

.list_users__item {
  width: 100%;
  height: 65px;
  background: #dde1eb;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
}

.list_users__item > p {
  position: relative;
  color: #424242;
  font-size: 14px;
  font-weight: 500;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.list_users__item > p::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #b2bac6;
}

.list_users__item > :nth-child(4)::after {
  display: none;
}

.list_users__item > :nth-child(4) {
  flex: 1 1;
}
.list_users__item.two > :nth-child(4):after
{
  display: block;
}

.list_users__item__actions {
  display: flex;
  gap: 8px;
  padding: 0 16px;
}



.list_users__item__actions > button, .list_users__item__actions > a > button {
  padding: 0 10px;
  height: 35px;
  border: 1px solid #b2bac6;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: #0c6b60;
  font-size: 13px;
  font-weight: 500;
}

.list_users__item__actions > .delete {
  border-color: #e0383d;
  color: #e0383d;
}

.list_orgs {
  min-width: 1024px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  list-style: none;
}

.list_orgs > :nth-child(odd) {
  background: transparent;
}

.list_orgs > :nth-child(odd) {
  border: 1px solid #dde1eb;
}

.list_orgs__header {
  width: 100%;
  display: flex;
  align-items: center;
  border: none !important;
}

.list_orgs__header > p {
  text-align: center;
  border-right: 1px solid #b2bac6;
  color: #b2bac6;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  padding: 10px;
}

.list_orgs__header > p.w150 {
  width: 150px;
}

.list_orgs__header > p.w180 {
  width: 180px;
}

.list_orgs__header > p.w450 {
  width: 450px;
}

.list_orgs__header > :nth-child(3) {
  border-right: none;
}

.list_orgs__item {
  width: 100%;
  height: 65px;
  background: #dde1eb;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
}

.list_orgs__item > p {
  position: relative;
  color: #424242;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.list_orgs__item > p.w180 {
  width: 180px;
}

.list_orgs__item > p.w450 {
  width: 450px;
}

.list_orgs__item > p::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #b2bac6;
}

.list_orgs__item > :nth-child(3)::after {
  display: none;
}

.list_orgs__item > :nth-child(3) {
  flex: 1 1;
}

.list_orgs__item__actions {
  display: flex;
  gap: 8px;
  padding: 0 16px;
}

.list_orgs__item__actions > button, .list_orgs__item__actions > a > button {
  padding: 0 10px;
  height: 35px;
  border: 1px solid #b2bac6;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: #0c6b60;
  font-size: 13px;
  font-weight: 500;
}

.list_orgs__item__actions > :last-child {
  border-color: #e0383d;
  color: #e0383d;
}

@media (max-width: 768px) {
  .home__content > h1 {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/home/home.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;;;AAIA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".home {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n}\n\n.home__content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.home__list {\n  width: 100%;\n  overflow: hidden;\n  overflow: auto;\n}\n\n.home__content > h1 {\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.list_users {\n  min-width: 1024px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  list-style: none;\n}\n\n.list_users > :nth-child(odd) {\n  background: transparent;\n}\n\n.list_users > :nth-child(odd) {\n  border: 1px solid #dde1eb;\n}\n\n.list_users__header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border: none !important;\n}\n\n.list_users__header > .w150 {\n  text-align: center;\n  border-right: 1px solid #b2bac6;\n  color: #b2bac6;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 10px;\n}\n\n.list_users__header > .w180 {\n  text-align: center;\n  border-right: 1px solid #b2bac6;\n  color: #b2bac6;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 10px;\n  padding: 10px;\n}\n\n.list_users__header > .w450 {\n  text-align: center;\n  color: #b2bac6;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 10px;\n  border-right: 1px solid #b2bac6;\n  padding: 10px;\n}\n\n.list_users__header > :last-child {\n  border-right: none;\n}\n\n.list_users .w150 {\n  width: 150px;\n  padding: 10px;\n}\n\n.list_users__item {\n  width: 100%;\n  height: 65px;\n  background: #dde1eb;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-radius: 8px;\n}\n\n.list_users__item > p {\n  position: relative;\n  color: #424242;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.list_users__item > p::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 30px;\n  background: #b2bac6;\n}\n\n.list_users__item > :nth-child(4)::after {\n  display: none;\n}\n\n.list_users__item > :nth-child(4) {\n  flex: 1;\n}\n.list_users__item.two > :nth-child(4):after\n{\n  display: block;\n}\n\n.list_users__item__actions {\n  display: flex;\n  gap: 8px;\n  padding: 0 16px;\n}\n\n\n\n.list_users__item__actions > button, .list_users__item__actions > a > button {\n  padding: 0 10px;\n  height: 35px;\n  border: 1px solid #b2bac6;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  color: #0c6b60;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.list_users__item__actions > .delete {\n  border-color: #e0383d;\n  color: #e0383d;\n}\n\n.list_orgs {\n  min-width: 1024px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  list-style: none;\n}\n\n.list_orgs > :nth-child(odd) {\n  background: transparent;\n}\n\n.list_orgs > :nth-child(odd) {\n  border: 1px solid #dde1eb;\n}\n\n.list_orgs__header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border: none !important;\n}\n\n.list_orgs__header > p {\n  text-align: center;\n  border-right: 1px solid #b2bac6;\n  color: #b2bac6;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 10px;\n}\n\n.list_orgs__header > p.w150 {\n  width: 150px;\n}\n\n.list_orgs__header > p.w180 {\n  width: 180px;\n}\n\n.list_orgs__header > p.w450 {\n  width: 450px;\n}\n\n.list_orgs__header > :nth-child(3) {\n  border-right: none;\n}\n\n.list_orgs__item {\n  width: 100%;\n  height: 65px;\n  background: #dde1eb;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-radius: 8px;\n}\n\n.list_orgs__item > p {\n  position: relative;\n  color: #424242;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.list_orgs__item > p.w180 {\n  width: 180px;\n}\n\n.list_orgs__item > p.w450 {\n  width: 450px;\n}\n\n.list_orgs__item > p::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 30px;\n  background: #b2bac6;\n}\n\n.list_orgs__item > :nth-child(3)::after {\n  display: none;\n}\n\n.list_orgs__item > :nth-child(3) {\n  flex: 1;\n}\n\n.list_orgs__item__actions {\n  display: flex;\n  gap: 8px;\n  padding: 0 16px;\n}\n\n.list_orgs__item__actions > button, .list_orgs__item__actions > a > button {\n  padding: 0 10px;\n  height: 35px;\n  border: 1px solid #b2bac6;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  color: #0c6b60;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.list_orgs__item__actions > :last-child {\n  border-color: #e0383d;\n  color: #e0383d;\n}\n\n@media (max-width: 768px) {\n  .home__content > h1 {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
